// Calendar day in the viewer's own time zone (YYYY-MM-DD). toISOString() is
// UTC, so after 8pm in Toronto it returns tomorrow's date.
export function localISO(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
